










































































































import { Component, Vue } from 'vue-property-decorator'
import { PHDController } from '@/services/request.service'
import moment from 'moment'
import { fileUploader } from '@/services/qiniu.service.new'
import { saveAs } from 'file-saver'
import { mapGetters } from 'vuex'
import RangePicker from '@/components/RangePicker.vue'
import UUID from 'uuidjs'

@Component({
  components: {
    RangePicker,
  },
  computed: {
    ...mapGetters(['getProgress']),
  },
})
export default class PHDCourseDetail extends Vue {
  private loading = false
  private phdCourseName = ''
  private phdCourseEnName = ''
  private courseNum = ''
  private suitableSection = ''
  private bookList: Array<any> = []
  private fileList: Array<any> = []
  private attachmentVisible = false
  private attachmentModalTitle = ''
  private activeBookId = 0

  private moment = moment

  private get locale(): string {
    return this.$store.state.locale
  }

  private get bundleId(): number {
    return parseInt(this.$route.params.bundleId, 10)
  }

  private get phdCourseHeader(): Array<any> {
    return [
      {
        title: this.$t('phdCourse.phdCourse'),
        scopedSlots: {
          customRender: 'name',
        },
      },
      {
        title: this.$t('phdCourse.courseOrder'),
        scopedSlots: {
          customRender: 'courseOrder',
        },
      },
      {
        title: this.$t('phdCourse.openDate'),
        scopedSlots: {
          customRender: 'openDate',
        },
      },
      {
        title: this.$t('phdCourse.materials'),
        scopedSlots: {
          customRender: 'materials',
        },
      },
    ]
  }

  private get fileHeader(): Array<any> {
    return [
      {
        title: this.$t('phdCourse.file'),
        width: '80%',
        scopedSlots: {
          customRender: 'file',
        },
      },
      {
        title: this.$t('common.operations'),
        width: '20%',
        scopedSlots: {
          customRender: 'operations',
        },
      },
    ]
  }

  private created(): void {
    this.phdCourseEnName = this.$route.query.enName as string
    this.phdCourseName = this.$route.query.name as string
    this.courseNum = this.$route.query.num as string
    this.suitableSection = this.$route.query.targetSection as string
    this.getBookList()
  }

  private getBookList(): void {
    PHDController.getPHDBooks(this.bundleId)
      .then(res => {
        this.bookList = res.data
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private viewBook(bookId, type): void {
    if (type === '1001') {
      this.$router.push({ name: 'phdCourseBook', params: { bookId } }).catch(err => {})
    } else if (type === '1002') {
      this.$router.push({ name: 'flashCard', params: { bookId } }).catch(err => {})
    }
  }

  private openMaterials(bookId, enName, name): void {
    this.attachmentVisible = true
    this.attachmentModalTitle =
      enName + ' ' + name + this.$t('phdCourse.has') + ' ' + this.$t('phdCourse.materials')
    this.activeBookId = bookId
    PHDController.getPictureBookResources(bookId)
      .then(res => {
        this.fileList = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private beforeFileUpload(file: any): boolean {
    const index = file.name.lastIndexOf('.')
    const suffix = file.name.slice(index).toLowerCase()
    const originName = file.name.slice(0, index).toLowerCase()
    const fileName = 'file_' + new Date().getTime() + '_' + UUID.genV4() + suffix
    const suffixArray = [
      '.pdf',
      '.docx',
      '.doc',
      '.xls',
      '.xlsx',
      '.ppt',
      '.pptx',
      '.jpg',
      '.jpeg',
      '.png',
      '.mp3',
      '.wmv',
      '.mp4',
      '.mov',
    ]
    if (suffixArray.includes(suffix)) {
      if (file.size > 104857600) {
        this.$message.error(this.$tc('phdCourse.attachmentOverLimit'))
      } else {
        let fileList = this.fileList
        fileList.push({
          resourceId: Math.random() * -1,
          resourceName: file.name,
          resourceSize: file.size,
          resourceUrl: '',
          fileName,
        })
        this.fileList = fileList
        const index = fileList.findIndex(item => item.resourceName === file.name)
        fileUploader(file, fileName, 'file')
          .then(res => {
            fileList[index].resourceId = res.resourceId
            fileList[index].resourceUrl = process.env.VUE_APP_FILE_URL + '/' + res.key
            this.fileList = fileList
            const pictureBookId = this.activeBookId
            const resourceId = res.resourceId
            PHDController.addPHDBookResources({ pictureBookId, resourceId })
              .then(res => {
                this.$message.success(this.$tc('common.uploadSuccess'))
              })
              .catch(err => {
                console.warn(err)
              })
          })
          .catch(err => {
            console.warn(err)
          })
      }
    } else {
      this.$message.error(this.$tc('phdCourse.uploadCorrectAttachment'))
    }
    return false
  }

  private download(resourceUrl, resourceName): void {
    saveAs(resourceUrl, resourceName)
  }

  private deleteFile(resourceId): void {
    PHDController.deletePictureBookResource(this.activeBookId, resourceId)
      .then(res => {
        this.$message.success(this.$tc('common.deleteSuccess'))
      })
      .catch(err => {
        console.warn(err)
      })
      .finally(() => {
        const index = this.fileList.findIndex(file => file.resourceId === resourceId)
        this.fileList.splice(index, 1)
      })
  }

  private previewFile(url): void {
    window.open(url, '_blank')
  }
}
